import dynamic from 'next/dynamic'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/possible-owners.png'

const PossibleOwners = dynamic(() => import('src/components/insights/property-records/possible-owners'), { ssr: false })

export const PossibleOwnersWidget: InsightBuilderWidget = {
  id: 'possible-owners',
  name: 'Possible Owners',
  type: 'Property Records',
  icon: PropertyRecordsIcon,
  component: PossibleOwners,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'entry',
}
